/* eslint-disable max-len */

import React, { useState } from 'react'
import { useNavigate } from "react-router-dom";
// import { Tooltip } from 'react-tooltip'
// import { Modal } from 'react-responsive-modal';  
import { useSelector } from 'react-redux';
import { dataService } from '../../../services/data.services';
import { checkPrivilege } from '../../../CommonMethods/checkPrivilege';
import Shimmer from '../../SupportTickets/Components/Shimmer';

export default function Table({ setEditData, setIsOpen, setState, GetList, loading }) {
    const { List, Categories } = useSelector(state => state.SupportList)

    const navigate = useNavigate()

    function getUserType(User) {
        if (User) {
            const parts = User.split("_");
            return parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
        }
        return '-'
    }
    const hasViewSupport = checkPrivilege('view_support_request')
    return (
        <div className='bg-white px-5 mt-[20px] overflow-auto h-[calc(100vh-350px)] scrollBar' data-testid="support-table">

            <table className="w-full px-5">

                {(loading || List.data?.length > 0) && <thead className='bg-[#FAFAFA] px-[20px] sticky top-0 right-0 z-[9]'>
                    <tr className="border-b-[1px] border-[#EEEEEE]" >
                        <th className="px-4 py-3.5 ">
                            <h1 className="text-base font-normal text-[#4B4B4B] text-left whitespace-nowrap">Ticket ID</h1>
                        </th>
                        <th className="px-4 py-3.5  ">
                            <h1 className="text-base font-normal text-[#4B4B4B] text-left whitespace-nowrap">Name</h1>
                        </th>
                        <th className="px-4 py-3.5 min-w-[140px]">
                            <h1 className="text-base font-normal text-[#4B4B4B] text-left whitespace-nowrap">Email Address</h1>
                        </th>
                        <th className="px-4 py-3.5 ">
                            <h1 className="text-base font-normal text-[#4B4B4B] text-left whitespace-nowrap">Phone Number</h1>
                        </th>
                        <th className="px-4 py-3.5 ">
                            <h1 className="text-base font-normal text-[#4B4B4B] text-left whitespace-nowrap">Severity</h1>
                        </th>
                        <th className="flex space-x-1 px-2 py-3.5 justify-start">
                            <h1 className="text-base font-normal text-[#4B4B4B] text-left">Status</h1>
                        </th>
                        <th className="px-4 py-3.5">
                            <h1 className="text-base font-normal text-[#4B4B4B] text-left whitespace-nowrap">Ticket Type</h1>
                        </th>
                        <th className="px-4 py-3.5">
                            <h1 className="text-base font-normal text-[#4B4B4B]">Action</h1>
                        </th>
                    </tr>
                </thead>}

                {loading ? <Shimmer column={8} /> :
                    (<tbody>{
                        List.data?.map((item, index) => (
                            <tr key={index} className={`${List.data.length - 1 === index ? '' : 'border-b border-[#EEEEEE]'}`}>
                                <td className="px-4 py-3.5">
                                    <h1 className="text-sm text-[#4B4B4B] font-normal">{item.ticket_id}</h1>
                                </td>

                                <td className="px-4 py-3.5 ">
                                    <h1 className="text-sm text-[#4B4B4B] font-normal " title={item.subject} >{item.name}</h1>
                                </td>

                                <td className="px-4 py-3.5">
                                    <h1 className="text-sm text-[#4B4B4B] font-normal">{item.email_address}</h1>
                                </td>
                                <td className="px-4 py-3.5">
                                    <h1 className="text-sm text-[#4B4B4B] font-normal text-left">{item.phone_number}</h1>
                                </td>
                                <td className="px-4 py-3.5">
                                    <h1 className="text-sm text-[#4B4B4B] font-normal text-left">{item.severity}</h1>
                                </td>

                                <td className=" px-2 py-3.5  " >
                                    <div className='flex justify-start gap-2 items-center text-right cursor-default'>
                                        <span>
                                            <img
                                                src={`/assets/images/${item.status}.svg`}
                                                alt={item.status}
                                                className='cursor-default' />
                                        </span>
                                        <p className="text-base font-normal text-[#4B4B4B]">{item.status}</p>

                                    </div>

                                    {/* onClick={() => handleSort('status') */}
                                </td>

                                <td className="px-4 py-3.5">
                                    <h1 className="text-sm text-left">Ticket raised by {getUserType(item.user_type)}</h1>
                                </td>

                                <td className="px-2 py-3.5"
                                    onClick={() => {
                                        if (hasViewSupport) {
                                            navigate(`/supports/view/${item.ticket_id}`)
                                        }
                                    }
                                    }>
                                    <div data-testid={`view-btn-${index}`}
                                        className={`hover:text-[#3f3f3f] ${hasViewSupport ? 'cursor-pointer' : 'cursor-not-allowed'} flex justify-center gap-2 items-center text-sm text-[#4B4B4B] font-normal`}>
                                        View
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>)
                }

            </table>
        </div>

    )
}
